var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnrolledWallets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67503",
    "data-name": "Group 67503",
    transform: "translate(-984 -756)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22414",
    "data-name": "Rectangle 22414",
    width: 72,
    height: 72,
    transform: "translate(984 756)",
    fill: "#fff5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-money-bill-wave",
    transform: "translate(996.036 710.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67459",
    "data-name": "Group 67459",
    transform: "translate(0.021 64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67458",
    "data-name": "Group 67458",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80509",
    "data-name": "Path 80509",
    d: "M23.962,89.938a7.981,7.981,0,1,1,7.981-7.981A7.989,7.989,0,0,1,23.962,89.938Zm0-11.971a3.99,3.99,0,1,0,3.99,3.99A3.995,3.995,0,0,0,23.962,77.967ZM9.995,71.981a2,2,0,1,0,2,2A2,2,0,0,0,9.995,71.981Zm25.938,5.986a2,2,0,1,0,2-2A2,2,0,0,0,35.933,77.967ZM9.995,83.952a2,2,0,1,0,2,2A2,2,0,0,0,9.995,83.952Zm25.938,5.986a2,2,0,1,0,2-2A2,2,0,0,0,35.933,89.938Zm-2,9.976a33.538,33.538,0,0,1-9-1.566,29.984,29.984,0,0,0-7.953-1.427,24.183,24.183,0,0,0-6.822.7,7.845,7.845,0,0,1-6.943-1.285A7.935,7.935,0,0,1,.021,89.938V74.878a10.056,10.056,0,0,1,6.451-9.34A21.263,21.263,0,0,1,13.989,64a33.552,33.552,0,0,1,9,1.566,29.984,29.984,0,0,0,7.953,1.427,24.192,24.192,0,0,0,6.822-.7,7.845,7.845,0,0,1,6.945,1.285,7.935,7.935,0,0,1,3.192,6.395v15.06a10.058,10.058,0,0,1-6.453,9.34A21.255,21.255,0,0,1,33.936,99.914ZM16.978,92.931a33.552,33.552,0,0,1,9,1.566,29.984,29.984,0,0,0,7.953,1.427,17.353,17.353,0,0,0,6.1-1.277,5.966,5.966,0,0,0,3.883-5.611V73.976a3.977,3.977,0,0,0-1.6-3.2,3.891,3.891,0,0,0-3.442-.64,27.769,27.769,0,0,1-7.929.852,33.551,33.551,0,0,1-9-1.566,29.984,29.984,0,0,0-7.953-1.427,17.344,17.344,0,0,0-6.1,1.277,5.966,5.966,0,0,0-3.883,5.611v15.06a3.977,3.977,0,0,0,1.6,3.2,3.881,3.881,0,0,0,3.44.638,27.778,27.778,0,0,1,7.929-.852Z",
    transform: "translate(-0.021 -64)",
    fill: "#ff8383"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrolledWallets);
export default __webpack_public_path__ + "static/media/enrolled-wallets.e087f87f78c7108f5030f6393282b47b.svg";
export { ForwardRef as ReactComponent };